import React from 'react';
import Icon from '../../../components/AppIcon';

const SessionStatistics = ({ statistics, loading }) => {
  const stats = [
    {
      label: 'Active Sessions',
      value: statistics?.totalActiveSessions || 0,
      icon: 'Activity',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Unique Devices',
      value: statistics?.uniqueDevices || 0,
      icon: 'Smartphone',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Locations',
      value: statistics?.uniqueLocations || 0,
      icon: 'MapPin',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Most Recent Login',
      value: statistics?.mostRecentLogin
        ? new Date(statistics?.mostRecentLogin?.login_time)?.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        : 'N/A',
      icon: 'Clock',
      color: 'text-info',
      bgColor: 'bg-info/10'
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[1, 2, 3, 4]?.map(i => (
          <div key={i} className="card animate-pulse">
            <div className="h-24 bg-muted rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats?.map((stat, index) => (
        <div key={index} className="card hover:shadow-lg transition-shadow">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SessionStatistics;